export default ({request}) => ({
  sysQuartzTaskListApi(data = {}) {
    return request({
      url: '/sys/sysQuartzTask/list',
      method: 'post',
      data,
    })
  },
  sysQuartzTaskDetailApi(data = {}) {
    return request({
      url: '/sys/sysQuartzTask/detail',
      method: 'post',
      data,
    })
  },
  sysQuartzTaskSaveApi(data = {}) {
    return request({
      url: '/sys/sysQuartzTask/add',
      method: 'post',
      data,
    })
  },
  sysQuartzTaskUpdateApi(data = {}) {
    return request({
      url: '/sys/sysQuartzTask/update',
      method: 'post',
      data,
    })
  },
  sysQuartzTaskDelApi(data = {}) {
    return request({
      url: '/sys/sysQuartzTask/delete',
      method: 'post',
      data,
    })
  },
  sysQuartzTaskRunApi(data = {}) {
    return request({
      url: '/sys/sysQuartzTask/run',
      method: 'post',
      data,
    })
  },
  sysQuartzTaskPauseApi(data = {}) {
    return request({
      url: '/sys/sysQuartzTask/pause',
      method: 'post',
      data,
    })
  },
  sysQuartzTaskResumeApi(data = {}) {
    return request({
      url: '/sys/sysQuartzTask/resume',
      method: 'post',
      data,
    })
  },
  sysQuartzTaskLogListApi(data = {}) {
    return request({
      url: '/sys/sysQuartzTaskLog/list',
      method: 'post',
      data,
    })
  },
})
